import ISvgProps from '../../../SvgLoader/ISvgProps';

function SvgPrayer(props: ISvgProps) {
	return (
		<svg width={60} height={60} fill="none" xmlns="http://www.w3.org/2000/svg">
			<g clipPath="url(#Prayer_svg__a)">
				<path
					d="m47.073 44.466-1.42-1.424c0-14.778.691-11.452-7.722-30.69a3.626 3.626 0 0 0-6.73 2.688l3.221 9.9a4.563 4.563 0 0 1 3.404 4.406v7.176a1.305 1.305 0 0 1-2.61 0v-7.175a1.957 1.957 0 0 0-3.912 0c0 16.186-1.304 13.225 8.217 22.668l7.552-7.55ZM26.74 10.435a3.63 3.63 0 0 0-4.67 1.918c-8.32 19.03-7.722 15.899-7.722 30.69l-1.42 1.42 7.551 7.552c9.416-9.403 8.217-6.441 8.217-22.668a1.957 1.957 0 0 0-3.913 0v7.175a1.305 1.305 0 0 1-2.609 0v-7.175a4.563 4.563 0 0 1 3.404-4.407l3.221-9.9a3.637 3.637 0 0 0-2.06-4.604h.001ZM0 53.477v6.522h19.565l2.61-2.609L9.131 44.348 0 53.477ZM50.868 44.348 37.826 57.39l2.61 2.61H60v-6.523l-9.132-9.13Z"
					fill={props.primaryColor}
				/>
				<path
					d="M31.303 1.306a1.304 1.304 0 1 0-2.606 0v5.216c0 .722.582 1.304 1.303 1.304s1.303-.582 1.303-1.304V1.306ZM4.957 18.091c4.943 2.842 4.708 2.778 5.177 2.778a1.305 1.305 0 0 0 .653-2.44l-4.526-2.61v.003a1.31 1.31 0 0 0-1.304 2.27ZM15.875 9.848c.423.523 1.174.64 1.736.269.563-.372.748-1.11.428-1.705L15.429 4.5h.003a1.306 1.306 0 0 0-2.167 1.436l2.61 3.913ZM3.913 32.61h5.219a1.305 1.305 0 0 0 0-2.61h-5.22a1.305 1.305 0 0 0 0 2.61ZM49.865 20.871c.47 0 .223.079 5.217-2.778a1.306 1.306 0 0 0-1.304-2.257l-4.527 2.61a1.3 1.3 0 0 0-.601 1.44c.142.562.636.96 1.215.985ZM43.042 10.435c.927 0 .94-.365 3.69-4.5h.003a1.305 1.305 0 0 0-2.167-1.436l-2.61 3.913h.003a1.304 1.304 0 0 0 1.081 2.023ZM50.868 32.61h5.22a1.305 1.305 0 0 0 0-2.61h-5.22a1.305 1.305 0 0 0 0 2.61Z"
					fill={props.secondaryColor}
				/>
			</g>
			<defs>
				<clipPath id="Prayer_svg__a">
					<path fill="#fff" d="M0 0h60v60H0z" />
				</clipPath>
			</defs>
		</svg>
	);
}

export default SvgPrayer;
